import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { fetchSubscriptionStatus } from '../../api/subscriptionApi'

export const getSubscriptionStatus = createAsyncThunk(
  'subscription/getSubscriptionStatus',
  async (_, { rejectWithValue }) => {
    try {
     const language = typeof localStorage !== 'undefined' ? localStorage.getItem('app_language') || 'en' : 'en'
      const response = await fetchSubscriptionStatus(language)
      return response
    } catch (error) {
      return rejectWithValue(error?.response || error)
    }
  }
)


const subscriptionSlice = createSlice({
  name: 'subscription',
  initialState: {
    subscriptionStatus: null,
    loading: false,
    error: null
  },
  reducers: {
    resetSubscriptionStatus(state) {
      state.subscriptionStatus = null
      state.loading = false
      state.error = null
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getSubscriptionStatus.pending, state => {
        state.loading = true
        state.error = null
      })
      .addCase(getSubscriptionStatus.fulfilled, (state, action) => {
        state.loading = false
        state.subscriptionStatus = action.payload
      })
      .addCase(getSubscriptionStatus.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  }
})

export const { resetSubscriptionStatus } = subscriptionSlice.actions
export default subscriptionSlice.reducer
